// FAQ under the /book-a-demo form (TICKET-13758). Pricing figures come from pricing-config so they match /pricing.
import { HOSTING_REGIONS, STARTING_PRICE, TRIAL_DAYS, TRIAL_PLANS } from './pricing-config';

export const BOOK_A_DEMO_FAQS = [
    {
        title: "Do you store my customers' data?",
        answer: 'No customer records are kept at rest. Reads and writes go to the source system at request time, so you get live data, not a synced copy. Connection credentials and operational metadata are encrypted at rest, and API logs never keep request or response bodies. Our SOC 2 Type II report is available on request.',
    },
    {
        title: "If you don't store data, how do I know when something changes?",
        answer: "Webhooks. Where a vendor has native webhooks, Unified forwards them. Where it doesn't, virtual webhooks detect changes on a set interval and deliver events to your endpoint. AI agents can receive changes through MCP Events.",
    },
    {
        title: 'What does it cost?',
        answer: `Pricing is usage-based, with unlimited connections on every plan, so your bill doesn't grow with every customer who connects. Plans start at $${STARTING_PRICE.toLocaleString('en-US')} a month, and ${TRIAL_PLANS.join(' and ')} include a ${TRIAL_DAYS}-day free trial. Every plan can be hosted in ${HOSTING_REGIONS.slice(0, -1).join(', ')} or ${HOSTING_REGIONS.at(-1)} data centers. <a href="/pricing" class="text-blue-500 hover:text-blue-400">See pricing</a>`,
    },
    {
        title: 'Can my AI agents use it safely?',
        answer: "Yes. Connection-scoped tokens limit each agent to one customer's connection. Permission scopes and tool allowlists limit which tools a model sees. <code>hide_sensitive</code> strips names, emails, phone numbers and other personal fields before results reach the model.",
    },
    {
        title: "What if you don't cover a field or endpoint I need?",
        answer: "Use the same connection. Passthrough calls the vendor's API directly, and raw fields return the vendor's original data alongside the unified fields.",
    },
];
